import { messages } from 'helpers/validationMessages'
import * as yup from 'yup'
import { TSuggest } from '../types'

export const stepTwoField = () =>
  yup
    .string()
    .max(100, messages.maxLength(100))
    .test('stepTwoRequired', messages.required, function (value) {
      const { step } = (this.options?.context || {}) as { step?: number }
      if (step === 2) {
        return !!value && value.trim() !== ''
      }
      return value ? value.trim() !== '' : true
    })

export const stepTwoArrayField = () =>
  yup
    .array()
    .of(yup.mixed<TSuggest>())
    .nullable()
    .test('stepTwoRequired', messages.required, function (value) {
      const { step } = (this.options?.context || {}) as { step?: number }
      if (step !== 2) {
        return true
      }
      return !!value && Array.isArray(value) && value.length > 0
    })
